import type { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

import type {
  ToothSliceAnatomicalBasis,
  ToothAnatomicalGeometry,
} from '../config';

import { toToothSliceVec3 } from './toToothSliceVec3';

const toProtocolBasis = (tooth: Tooth): ToothSliceAnatomicalBasis | null => {
  const basis = tooth.OriginatedPosition?.AnatomicalBasis;
  const crownRoot = toToothSliceVec3(basis?.Axial);
  const mesioDistal = toToothSliceVec3(basis?.MesioDistal);
  const vestibuloOral = toToothSliceVec3(basis?.VestibuloOral);

  return crownRoot && mesioDistal && vestibuloOral
    ? { crownRoot, mesioDistal, vestibuloOral }
    : null;
};

export const resolveToothGeometry = ({
  tooth,
}: {
  tooth: Tooth;
}): ToothAnatomicalGeometry | null => {
  const protocolOrigin = toToothSliceVec3(tooth.OriginatedPosition?.Origin);
  const protocolBasis = toProtocolBasis(tooth);

  if (!protocolOrigin) {
    return null;
  }

  return {
    anatomicalBasis: protocolBasis,
    origin: protocolOrigin,
    source: 'protocol',
  };
};
